import React from "react";
import { useTranslation } from "react-i18next";

function Contact() {
  const { t } = useTranslation(); // Translation hook

  return (
    <div className="text-center">
      <h1>{t('contact_us')}</h1> {/* Translated "Contact Us" */}
      <p className="mt-3">
        {t('contact_page_intro')} {/* Translated introduction */}
      </p>
      <div className="mt-4">
        <h3>{t('call_to_order')}</h3> {/* Translated "Call today to place your order!" */}
        <p>
          <i className="fab fa-whatsapp"></i>{" "}
          <a href="tel:+263715112658">+263 715 112 658</a>
        </p>
      </div>
    </div>
  );
}

export default Contact;
